exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\ncanvas {\r\n    display: block;\r\n    vertical-align: bottom;\r\n  }\r\n  \r\n  /* ---- particles.js container ---- */\r\n  \r\n  #particles-js {\r\n    position: absolute;\r\n    width: 100vw;\r\n    height: 100vh;\r\n    background-color: black;\r\n    background-image: url(\"/assets/img/background.jpg\");\r\n    background-repeat: no-repeat;\r\n    background-size: cover;\r\n    background-position: 50% 50%;\r\n  }\r\n\r\n  .bg-login {\r\n    background: rgba(255, 255, 255, 0.04);\r\n    box-shadow: -1px 4px 28px 0px rgba(0,0,0,0.75);\r\n    border: none !important;\r\n  }\r\n\r\n  .your-ip {\r\n    position: absolute;\r\n    bottom: 0;\r\n    right: 1rem;\r\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/auth/auth.component.css
// module id = ../../../../../src/app/views/auth/auth.component.css
// module chunks = main